import React from "react";

import { useIsMobile } from "../../hooks/useIsMobile";
import { If } from "./If";

export const IfIsNotMobile = ({ children }) => {
  const isMobile = useIsMobile();
  return <If cond={!isMobile}>{children}</If>;
};
